import { useApp } from 'contexts/app';
import InstructorViewFormativeSubmissionPage from 'pages/InstructorViewFormativeSubmission';
import PageLayout from 'pages/InstructorViewSubmission/PageLayout';
import PageProvider from 'pages/InstructorViewSubmission/PageProvider';
import { useParams } from 'react-router-dom';
import { Loading } from 'shell/components';

const InstructorViewSubmissionPage = ({ ...props }) => {
    const { submissions, studentSubmissions } = useApp();
    const { submissionId } = useParams();

    const currentSubmission =
        [...(submissions || []), ...(studentSubmissions || [])].find(({ id }) => id === submissionId) || null;

    if (!currentSubmission) return <Loading />;

    if (currentSubmission.type === 'formative') return <InstructorViewFormativeSubmissionPage />;

    return (
        <PageProvider {...props}>
            <PageLayout {...props} />
        </PageProvider>
    );
};

export default InstructorViewSubmissionPage;
